module.exports = __webpack_public_path__ + "img/80.cc1f1248.svg";